export class ResourceTypeToSecurityGroup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreServer",
            "baseName": "restoreServer",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "restoredRdsInstance",
            "baseName": "restoredRdsInstance",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceTypeToSecurityGroup.attributeTypeMap;
    }
    constructor() {
    }
}
